import React, { useEffect } from 'react';
import Navbar from './landing/Navbar';
import Hero from './landing/Hero';
import DidYouKnow from './landing/DidYouKnow';
import ThisWeekInHistory from './landing/ThisWeekInHistory';
import Features from './landing/Features';
import LearningPaths from './landing/LearningPaths';
import AITutorDemo from './landing/AITutorDemo';
import Stats from './landing/Stats';
import FAQ from './landing/FAQ';
import Footer from './landing/Footer';
import { trackEvent } from '../utils/analytics';

function LandingPage() {
  useEffect(() => {
    trackEvent("landing_page_view");
  }, []);

  return (
    <div className="min-h-screen bg-dark-500">
      <Navbar />
      <Hero />
      <Features />
      <LearningPaths />

      {/* Knowledge Row — two compact cards side-by-side */}
      <section className="section-padding relative">
        <div className="container-custom mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <DidYouKnow />
            <ThisWeekInHistory />
          </div>
        </div>
      </section>

      <AITutorDemo />
      <Stats />
      <FAQ />
      <Footer />
    </div>
  );
}

export default LandingPage;
